import { createContext, useContext } from "react";

export const TenantContext = createContext({
  features: {},
  limits: {},
  usage: null,
  config: {},
  operational_flags: {},
  user_id: null,
  geography: null,
  plan_code: null,
  plan_name: null,
});

export function useTenant() {
  return useContext(TenantContext);
}

export function hasFeature(features, key) {
  return features?.[key] === true;
}
